import * as Sentry from '@sentry/react';
import { useMatch } from 'react-location';
import { styled } from '@mui/material/styles';
// @mui
import { Box, Button, Typography, Container, Link } from '@mui/material';
// components
import Page from '../components/Page';
import RouterLink from 'src/components/RouterLink';
// illustrations
import ServerErrorIllustration from 'src/assets/illustration_error_alien';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

export default function Page500() {
  const { error } = useMatch();

  if (error) {
    Sentry.captureException(error);
  }

  const supportEmail = 'support@getlovage.com';
  return (
    <Page title="500 Internal Server Error" sx={{ height: 1 }}>
      <RootStyle>
        <Container>
          <Box sx={{ maxWidth: 600, margin: 'auto', textAlign: 'center' }}>
            <Typography variant="h3" paragraph>
              500 Internal Server Error
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              There was an error, please try again later.
              <br />
              <br />
              Still having errors? Please contact us at&nbsp;
              <Link
                href={`mailto:${supportEmail}?subject=Lovage Dashboard Error`}
                target="_blank"
                rel="noreferrer"
              >
                {supportEmail}
              </Link>
              .
            </Typography>

            <ServerErrorIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />

            <Button to="/" size="large" variant="contained" component={RouterLink}>
              Go to Home
            </Button>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
